import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slots", "slot"]

  connect() {
    this.draggedSlot = null
  }

  dragStart(event) {
    this.draggedSlot = event.target.closest("[data-build-skill-order-target~='slot']")
    if (!this.draggedSlot) return

    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", "skill")
  }

  dragOver(event) {
    event.preventDefault()
  }

  drop(event) {
    event.preventDefault()
    const targetSlot = event.target.closest("[data-build-skill-order-target~='slot']")
    if (!this.draggedSlot || !targetSlot || targetSlot === this.draggedSlot) return

    const insertAfter = event.clientX > targetSlot.getBoundingClientRect().left + targetSlot.offsetWidth / 2
    if (insertAfter) targetSlot.after(this.draggedSlot)
    else targetSlot.before(this.draggedSlot)
    this.refreshLabels()
  }

  dragEnd() {
    this.draggedSlot = null
  }

  moveWithKeyboard(event) {
    if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return

    const slot = event.currentTarget
    const direction = event.key === "ArrowLeft" ? "left" : "right"
    if (!this.moveSlot(slot, direction)) return

    event.preventDefault()
    slot.focus()
  }

  moveLeft(event) {
    this.moveWithButton(event, "left")
  }

  moveRight(event) {
    this.moveWithButton(event, "right")
  }

  moveWithButton(event, direction) {
    const slot = event.currentTarget.closest("[data-build-skill-order-target~='slot']")
    if (!this.moveSlot(slot, direction)) return

    slot.focus()
  }

  moveSlot(slot, direction) {
    if (!slot) return false

    const neighbor = direction === "left" ? slot.previousElementSibling : slot.nextElementSibling
    if (!neighbor) return false

    if (direction === "left") neighbor.before(slot)
    else neighbor.after(slot)
    this.refreshLabels()
    return true
  }

  refreshLabels() {
    this.slotTargets.forEach((slot, index) => {
      const slotNumber = index + 1
      const skillName = slot.dataset.skillName
      slot.setAttribute(
        "aria-label",
        `Skill slot ${slotNumber}: ${skillName}; use move buttons, drag, or left and right arrow keys to reorder`
      )

      const skillId = slot.querySelector("[data-build-skill-order-target~='skillId']")?.value
      const chooseButton = slot.querySelector("[data-skill-picker-target='chooseButton']")
      if (chooseButton) {
        const label = skillId === "0"
          ? `Choose a skill for slot ${slotNumber}`
          : `Replace skill in slot ${slotNumber}: ${skillName}`
        chooseButton.setAttribute("aria-label", label)
      }

      const removeButton = slot.querySelector("[data-skill-picker-target='removeButton']")
      removeButton?.setAttribute("aria-label", `Remove skill from slot ${slotNumber}`)

      const moveLeftButton = slot.querySelector("[data-build-skill-order-target~='moveLeftButton']")
      const moveRightButton = slot.querySelector("[data-build-skill-order-target~='moveRightButton']")
      if (moveLeftButton) {
        moveLeftButton.disabled = index === 0
        moveLeftButton.setAttribute("aria-label", `Move skill in slot ${slotNumber} left`)
      }
      if (moveRightButton) {
        moveRightButton.disabled = index === this.slotTargets.length - 1
        moveRightButton.setAttribute("aria-label", `Move skill in slot ${slotNumber} right`)
      }
    })
  }
}
